import type { CouponType } from '@cencosud-cencommerce/paris-uikit';
import type { CouponData } from '@cencosud-cencommerce/paris-uikit/dist/utils/types/PurchaseSummary.type';

import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  type Cart,
  type DiscountCodeInfo,
  EDiscoutCodeState
} from '@/modules/cart/domain/Cart';
import { formatPrice } from '@/modules/perseo-billing/hooks';

const calculateDiscountAmount = (cart: Cart, idToFind: string) => {
  let amount = 0;

  cart?.lineItems?.forEach((lineItem) => {
    lineItem?.discountedPricePerQuantity?.forEach((discountedPrice) => {
      const quantity = discountedPrice?.quantity ?? 0;

      discountedPrice?.discountedPrice?.includedDiscounts.forEach(
        (discount) => {
          if (discount?.discount?.id === idToFind) {
            const price = discount?.discountedAmount?.centAmount;
            amount += quantity * price;
          }
        }
      );
    });
  });

  cart?.deliveryInfo?.deliveryGroups?.forEach((deliveryGroup) => {
    deliveryGroup?.includedDiscounts?.forEach((discount) => {
      if (discount?.discount?.id === idToFind) {
        const price = discount?.discountedAmount?.centAmount;
        amount += price;
      }
    });
  });

  return amount;
};

const mapCouponToCouponType = (
  coupon: DiscountCodeInfo,
  cart: Cart
): CouponType => {
  const couponInfo = coupon?.discountCode.obj;
  let amount = 0;

  couponInfo?.cartDiscounts?.forEach((discount) => {
    const idToFind = discount?.id;
    amount += calculateDiscountAmount(cart, idToFind);
  });

  const doesNotMatchCart = coupon.state === EDiscoutCodeState.DoesNotMatchCart;

  return {
    couponId: couponInfo?.id ?? '',
    couponName: couponInfo?.code ?? '',
    discountAmount: formatPrice(amount),
    variant: doesNotMatchCart ? 'error' : 'positive'
  };
};

export const useGetCouponCartData = () => {
  const { data: cart } = useAppSelector((state) => state.cart);

  if (!cart) return undefined;

  const coupons =
    cart?.discountCodes?.map((coupon) => mapCouponToCouponType(coupon, cart)) ??
    [];

  const couponData: CouponData = {
    coupons
  };

  return couponData;
};
